import BannerNetworks from "./Networks";

export default BannerNetworks;
